import { useState, useEffect } from 'react';
import { doc, onSnapshot, setDoc } from 'firebase/firestore';
import { db } from '../firebase';

export interface AnalyticsColors {
    web_connected: string;
    web_anonymous: string;
    flyer_connected: string;
    flyer_anonymous: string;
    facebook_connected: string;
    facebook_anonymous: string;
}

const DEFAULT_COLORS: AnalyticsColors = {
    web_connected: '#42a5f5',
    web_anonymous: '#546e7a',
    flyer_connected: '#AA7D41',
    flyer_anonymous: '#6d4c41',
    facebook_connected: '#1877F2',
    facebook_anonymous: '#89b6f8'
};

export const useAnalyticsSettings = () => {
    const [colors, setColors] = useState<AnalyticsColors>(DEFAULT_COLORS);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const docRef = doc(db, 'analytics_settings', 'colors');

        const unsubscribe = onSnapshot(docRef, (doc) => {
            if (doc.exists()) {
                setColors({ ...DEFAULT_COLORS, ...doc.data() } as AnalyticsColors);
            } else {
                // Initialize if doesn't exist
                setDoc(docRef, DEFAULT_COLORS, { merge: true });
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    const updateColor = async (key: keyof AnalyticsColors, color: string) => {
        const docRef = doc(db, 'analytics_settings', 'colors');
        await setDoc(docRef, { [key]: color }, { merge: true });
    };

    return { colors, loading, updateColor };
};
